// Shared site configuration consumed by both the React app and Node build scripts.
const siteConfig = {
  gaMeasurementId: process.env.GA_ID || process.env.REACT_APP_GA_ID || 'G-9CZQC07K19',
  cookieConsent: {
    storageKey: 'talkabout_finance_cookie_consent',
    policyUrl: '/privacy',
  },
};

// Support both ESM (CRA) and CommonJS (node scripts)
module.exports = siteConfig;
module.exports.default = siteConfig;
